// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dedicated-admin-org-list--container {
  /* Style for last child */
}
.dedicated-admin-org-list--container .p-datatable .p-datatable-tbody > tr > td:first-child {
  border-radius: 4px 0px 0px 4px;
}
.dedicated-admin-org-list--container .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-radius: 0px 4px 4px 0px;
}
.dedicated-admin-org-list--container .p-datatable .p-datatable-tbody > tr > td {
  background-color: rgb(235, 235, 235);
  max-width: 3.5vw;
}
.dedicated-admin-org-list--container .p-datatable .p-datatable-tbody > tr.selected > td {
  background-color: rgb(200, 200, 200);
}
.dedicated-admin-org-list--container .p-datatable-table {
  border-collapse: separate;
  border-spacing: 0 10px;
}
.dedicated-admin-org-list--container .p-datatable-loading-overlay {
  display: none !important;
}
.dedicated-admin-org-list--container .p-icon-wrapper {
  display: none;
}
.dedicated-admin-org-list--container .admin--list {
  width: 15vw;
  min-width: 15vw;
}
.dedicated-admin-org-list--container .add_organization {
  margin-bottom: 27px;
  height: 78px;
}
.dedicated-admin-org-list--container .p-datatable .p-datatable-tbody > tr.disabled {
  cursor: not-allowed !important;
  pointer-events: none;
  opacity: 0.5;
}

.p-dropdown {
  width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/dedicated_admin/home/dedicated-admin-organisation-list/dedicated-admin-organisation-list.component.scss"],"names":[],"mappings":"AAAA;EAKI,yBAAA;AAHJ;AADI;EACI,8BAAA;AAGR;AACI;EACI,8BAAA;AACR;AAEI;EACI,oCAAA;EAEA,gBAAA;AADR;AAII;EACI,oCAAA;AAFR;AAKI;EACI,yBAAA;EACA,sBAAA;AAHR;AAMI;EACI,wBAAA;AAJR;AAOI;EACI,aAAA;AALR;AAQI;EACI,WAAA;EACA,eAAA;AANR;AASI;EACI,mBAAA;EACA,YAAA;AAPR;AAUI;EACI,8BAAA;EACA,oBAAA;EACA,YAAA;AARR;;AAcA;EACI,YAAA;AAXJ","sourcesContent":[".dedicated-admin-org-list--container {\n    .p-datatable .p-datatable-tbody > tr > td:first-child {\n        border-radius: 4px 0px 0px 4px;\n    }\n\n    /* Style for last child */\n    .p-datatable .p-datatable-tbody > tr > td:last-child {\n        border-radius: 0px 4px 4px 0px;\n    }\n\n    .p-datatable .p-datatable-tbody > tr > td {\n        background-color: rgb(235, 235, 235);\n        // height: 3vh;\n        max-width: 3.5vw;\n    }\n\n    .p-datatable .p-datatable-tbody > tr.selected > td {\n        background-color: rgb(200, 200, 200);\n    }\n\n    .p-datatable-table {\n        border-collapse: separate;\n        border-spacing: 0 10px;\n    }\n\n    .p-datatable-loading-overlay {\n        display: none !important;\n    }\n\n    .p-icon-wrapper {\n        display: none;\n    }\n\n    .admin--list {\n        width: 15vw;\n        min-width: 15vw;\n    }\n\n    .add_organization {\n        margin-bottom: 27px;\n        height: 78px;\n    }\n\n    .p-datatable .p-datatable-tbody > tr.disabled {\n        cursor: not-allowed !important;\n        pointer-events: none;\n        opacity: 0.5;\n    }\n\n\n}\n\n.p-dropdown {\n    width: 150px\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
